import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/shared/ui/table.tsx"
import { SocialPostTypeWithFeedback } from "../types"
import SocialCard from "./SocialCard"
import { IconStarFilled } from "@tabler/icons-react"

interface ExpandedRowContentProps {
  row: SocialPostTypeWithFeedback
}

export function ExpandedRowContent({
  row,
}: ExpandedRowContentProps) {

  return (
    <div className="flex items-start gap-2">
      <SocialCard content={row} />
      <div className="w-2/3 p-3">
        <h4 className="font-medium mb-3">Feedback</h4>
        <div className="border rounded-md">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="h-10">ID</TableHead>
                <TableHead className="h-10">Feedback</TableHead>
                <TableHead className="h-10">Rating</TableHead>
                <TableHead className="h-10">User</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {row.feedback.map((detail, index) => (
                <TableRow key={index}>
                  <TableCell className="font-mono text-sm">{index+1}</TableCell>
                  <TableCell className="font-medium">{detail.feedback}</TableCell>
                  <TableCell className="font-medium flex">{detail.rating === null ? "-" : (new Array(detail.rating).fill(1).map((_, index) => (
                    <IconStarFilled key={index} color="#ffca4d" />
                  )))}</TableCell>
                  <TableCell className="text-sm">{detail.user}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  )
}
